// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_material-icons_iconfont_material-icons_css"], () => (__webpack_require__("./wp-content/themes/gelencsermelania/assets/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
